<template>
  <div>
    <section class="itb-hero-cards">
      <div class="container d-flex flex-column">
        <div v-for="(category, index) in mainCategories" :key="index" class="position-relative" :class="[
          {
            'pt-5': isResponsive500 && index == 0,
            'pb-3': category.gallery && category.gallery.length,
            'pb-0': !category.gallery || !category.gallery.length,
          },
          category.gallery && category.gallery.length
            ? 'order-' + category.id
            : '',
        ]">
          <carousel :perPage="1" :navigateTo="defaultSlides[category.bgxref]
            ? defaultSlides[category.bgxref] - 1
            : 0
            " :speed="500" @page-change="
              currentCategory = category.bgxref;
            savePageCarousel($event);
            " @transition-end="isTransitionEnded += 1" class="position-relative" :touchDrag="true"
            :paginationActiveColor="'#0089cf'" :paginationColor="'#a2a2a2'" :paginationPosition="'bottom-overlay'">
            <slide v-for="(galleryImage, indexGallery) in category.gallery" :key="indexGallery"
              class="itb-hero-card itb-hero-card-home mx-0 itb-lazy-loading-bg w-100" v-lazy:background-image="'/uploads/' + galleryImage.path + '/' + galleryImage.name
                " :class="category.bgxref == 'playhop' ? 'itb-hero-card-home-playhop' : ''
                  ">
            </slide>
          </carousel>
          <div class="col-12 col-md-6 text-nowrap px-0 itb-main-category-home-text-left" v-if="
            category.id % 2 > 0 && category.gallery && category.gallery.length
          ">
            <div class="itb-card">
              <h2 v-html="$t('constants.' + category.title)"></h2>
              <p v-html="$t('constants.' + category.subtitle)"></p>
              <router-link :to="{ name: 'mainCategory-' + category.id }" class="btn btn-secondary itb-btn-icon">
                {{ $t("home.i_want_to_know_more") }}
                <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.i_want_to_know_more')"
                  class="itb-icon itb-angle-right-icon" />
              </router-link>
            </div>
          </div>
          <div class="col-12 col-md-6 d-flex" v-else></div>

          <div class="col-12 col-md-6 mt-md-0 px-0 text-nowrap itb-main-category-home-text-right" v-if="
            category.id % 2 == 0 &&
            category.gallery &&
            category.gallery.length
          " :class="category.bgxref == 'playhop'
            ? 'itb-main-category-home-text-playhop'
            : ''
            ">
            <div class="itb-card ml-auto right">
              <h2 v-html="$t('constants.' + category.title)"></h2>
              <div v-if="category.id == 100" style="margin-left: 5px; margin-bottom: 30px">
                <img class="itb-streetmark-logo-home" src="images/logo-streetmark.webp" alt="logo-streetmark" />
              </div>
              <p v-html="$t('constants.' + category.subtitle)"></p>
              <a v-if="category.id == 100" href="https://www.streetmark.cz/" target="_blank"
                class="btn btn-primary itb-btn-icon">
                {{ $t("home.i_want_to_know_more") }}
                <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.i_want_to_know_more')"
                  class="itb-icon itb-angle-right-icon" />
              </a>
              <router-link v-else :to="{ name: 'mainCategory-' + category.id }" class="btn btn-primary itb-btn-icon">
                {{ $t("home.i_want_to_know_more") }}
                <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.i_want_to_know_more')"
                  class="itb-icon itb-angle-right-icon" />
              </router-link>


            </div>
          </div>
        </div>
        <div v-for="category in mainCategories" v-if="!category.gallery || !category.gallery.length"
          class="itb-hero-card itb-hero-card-home row d-flex align-content-center mx-0 itb-lazy-loading-bg"
          style="background-size: cover" v-lazy:background-image="category.image && !isResponsive
            ? '/uploads/' + category.image
            : '/images/articles/blank-bg.webp'
            " :class="'order-' + category.id">
          <div v-if="isResponsive" class="itb-hero-responsive-image itb-lazy-loading-bg" v-lazy:background-image="category.image ? '/uploads/' + category.image : ''
            "></div>
          <div class="col-12 col-md-6 text-nowrap px-0" v-if="category.id % 2 > 0">
            <div class="itb-card">
              <h2 v-html="$t('constants.' + category.title)"></h2>
              <p v-html="$t('constants.' + category.subtitle)"></p>
              <router-link :to="{ name: 'mainCategory-' + category.id }" class="btn btn-secondary itb-btn-icon">
                {{ $t("home.i_want_to_know_more") }}
                <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.i_want_to_know_more')"
                  class="itb-icon itb-angle-right-icon" />
              </router-link>
            </div>
          </div>
          <div class="col-12 col-md-6 d-flex" v-else></div>

          <div class="col-12 col-md-6 mt-md-0 px-0 text-nowrap" v-if="category.id % 2 == 0">
            <div class="itb-card ml-auto right">
              <h2 v-html="$t('constants.' + category.title)"></h2>
              <div v-if="category.id == 100" style="margin-left: 5px; margin-bottom: 30px">
                <img class="itb-streetmark-logo-home" src="images/logo-streetmark.webp" alt="logo-streetmark" />
              </div>
              <p v-html="$t('constants.' + category.subtitle)"></p>
              <a v-if="category.id == 100" href="https://www.streetmark.cz/" target="_blank"
                class="btn btn-primary itb-btn-icon">
                {{ $t("home.i_want_to_know_more") }}
                <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.i_want_to_know_more')"
                  class="itb-icon itb-angle-right-icon" />
              </a>
              <router-link v-else :to="{ name: 'mainCategory-' + category.id }" class="btn btn-primary itb-btn-icon">
                {{ $t("home.i_want_to_know_more") }}
                <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.i_want_to_know_more')"
                  class="itb-icon itb-angle-right-icon" />
              </router-link>


            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="itb-home-insta">
      <div class="container text-center">
        <h2 class="mb-5">{{ $t("home.instagram_news") }}</h2>
        <insta-posts></insta-posts>
        <a class="btn btn-primary itb-btn-icon mt-4" :href="appParams.general_instagram" target="_blank">
          {{ $t("home.see_our_instagram") }}
          <img src="/images/icons/4soft_icon_angle-right.svg" :alt="$t('home.see_our_instagram')"
            class="itb-icon itb-angle-right-icon" />
        </a>
      </div>
    </section>
    <section class="mt-5" v-if="youtubeUrl">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex flex-column align-items-center itb-youtube-video">
            <h2 class="text-center">
              {{ $t("general.samples_of_our_work") }}
            </h2>
            <div class="d-flex justify-content-center align-items-center itb-youtube-warning-wrap">
              <p class="mb-0 itb-youtube-warning" style="font-size: 1.71rem; max-width: 1180px" :class="{
                'itb-youtube-warning-highlight': isYoutubeHighlighted,
              }">
                {{ $t("general.youtube_warning") }}
                <a href="https://policies.google.com/privacy" target="_blank">{{ $t("general.youtube_policy") }}.</a>
              </p>
              <button class="btn btn-secondary ml-2" :disabled="youtubePermit" @click="allowYoutubeVideos">
                {{ $t("cookies.accept") }}
              </button>
            </div>
            <div v-if="!youtubePermit"
              class="itb-youtube-image itb-youtube-video-homepage d-flex justify-content-center align-items-center"
              @click="warningHighlight">
              <img src="/images/youtube-logo.png" alt="youtube-logo" />
            </div>
            <iframe class="itb-youtube-video-homepage" :src="youtubeUrl + '&autoplay=1&loop=1'" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
              v-else></iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      mainCategories: [],
      isResponsive: false,
      isResponsive500: false,
      defaultSlides: {},
      currentCategory: "",
      nextDefaultSlides: {},
      isTransitionEnded: 0,
      automaticPageChange: 0,
      randomYoutubeVideoLinks: [],
      youtubePermit: false,
      isYoutubeHighlighted: false,
      youtubeUrl: "",
    };
  },

  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    this.getVideoLink();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  mounted() {
    axios
      .get("/getHomePage")
      .then((response) => {
        this.mainCategories = response.data.mainCategories;
        this.loadPageCarousel();

        this.pageParams = response.data.params;
        this.pageParams.achievementClass = "itb-smaller";
        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({ appParams: "getAppParams" }),
  },

  methods: {
    ...mapActions(["setPageParams", "setFormParams"]),

    onResize() {
      if (window.innerWidth < 768) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }

      if (window.innerWidth < 501) {
        this.isResponsive500 = true;
      } else {
        this.isResponsive500 = false;
      }
    },
    savePageCarousel(page) {
      // function is executed automatically while loading page if defaultSlides value is greater than one
      //in following visits the slide shown will be the one that follows the saved one

      var gallerySize = this.mainCategories.find(
        (category) => category.bgxref === this.currentCategory
      ).gallery.length;
      if (page + 1 == gallerySize) {
        this.nextDefaultSlides[this.currentCategory] = 1;
      } else {
        this.nextDefaultSlides[this.currentCategory] = page + 2;
      }

      axios
        .post("/saveDefaultSlidesHome", this.nextDefaultSlides)
        .then((response) => { })
        .catch((error) => {
          console.log(error);
        });
      // }
    },
    saveCurrentPagesCarousel() {
      axios
        .post("/saveDefaultSlidesHome", this.nextDefaultSlides)
        .then((response) => { })
        .catch((error) => {
          console.log(error);
        });
    },
    loadPageCarousel() {
      axios
        .get("/getDefaultSlidesHome")
        .then((response) => {
          this.defaultSlides = response.data ? response.data : {};

          //default slides are set to 1 and saved for the first time or after laravel session expires
          //in following visits the slide shown will be the one that follows the saved one
          if (Object.keys(this.defaultSlides).length === 0) {
            Object.values(this.mainCategories).forEach((category) => {
              if (category.gallery && category.gallery.length > 0) {
                this.defaultSlides[category.bgxref] = 1;
                this.nextDefaultSlides[category.bgxref] = 2;
              }
            });
          } else {
            Object.values(this.mainCategories).forEach((category) => {
              if (category.gallery && category.gallery.length > 0) {
                //after last slide of each category, the next to be shown would be the first one, closing the loop
                if (
                  this.defaultSlides[category.bgxref] < category.gallery.length
                ) {
                  this.nextDefaultSlides[category.bgxref] =
                    this.defaultSlides[category.bgxref] + 1;
                } else {
                  this.nextDefaultSlides[category.bgxref] = 1;
                }
              }
            });
          }
          //Values assigned here are only used if defaultSlides value is equal to one.
          //By assigning a value greater than one to defaultSlides page changes and triggers savePageCarousel function
          this.saveCurrentPagesCarousel();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getVideoLink() {
      await axios
        .get("/get-video-link")
        .then((response) => {
          this.youtubeUrl = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    warningHighlight() {
      this.isYoutubeHighlighted = true;
      setTimeout(() => {
        this.isYoutubeHighlighted = false;
      }, 1500);
    },

    allowYoutubeVideos() {
      this.youtubePermit = true;
    },
  },
};
</script>
